export default __webpack_public_path__ + "static/media/mongodb-atlas-logo.cc230be7a73cdf084995763ecfc90068.png";